module.exports = __webpack_public_path__ + "img/farm.56184c0f.svg";